import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.g51_1 = new (HttpStatusCode())(100, 'Continue');
        this.h51_1 = new (HttpStatusCode())(101, 'Switching Protocols');
        this.i51_1 = new (HttpStatusCode())(102, 'Processing');
        this.j51_1 = new (HttpStatusCode())(200, 'OK');
        this.k51_1 = new (HttpStatusCode())(201, 'Created');
        this.l51_1 = new (HttpStatusCode())(202, 'Accepted');
        this.m51_1 = new (HttpStatusCode())(203, 'Non-Authoritative Information');
        this.n51_1 = new (HttpStatusCode())(204, 'No Content');
        this.o51_1 = new (HttpStatusCode())(205, 'Reset Content');
        this.p51_1 = new (HttpStatusCode())(206, 'Partial Content');
        this.q51_1 = new (HttpStatusCode())(207, 'Multi-Status');
        this.r51_1 = new (HttpStatusCode())(300, 'Multiple Choices');
        this.s51_1 = new (HttpStatusCode())(301, 'Moved Permanently');
        this.t51_1 = new (HttpStatusCode())(302, 'Found');
        this.u51_1 = new (HttpStatusCode())(303, 'See Other');
        this.v51_1 = new (HttpStatusCode())(304, 'Not Modified');
        this.w51_1 = new (HttpStatusCode())(305, 'Use Proxy');
        this.x51_1 = new (HttpStatusCode())(306, 'Switch Proxy');
        this.y51_1 = new (HttpStatusCode())(307, 'Temporary Redirect');
        this.z51_1 = new (HttpStatusCode())(308, 'Permanent Redirect');
        this.a52_1 = new (HttpStatusCode())(400, 'Bad Request');
        this.b52_1 = new (HttpStatusCode())(401, 'Unauthorized');
        this.c52_1 = new (HttpStatusCode())(402, 'Payment Required');
        this.d52_1 = new (HttpStatusCode())(403, 'Forbidden');
        this.e52_1 = new (HttpStatusCode())(404, 'Not Found');
        this.f52_1 = new (HttpStatusCode())(405, 'Method Not Allowed');
        this.g52_1 = new (HttpStatusCode())(406, 'Not Acceptable');
        this.h52_1 = new (HttpStatusCode())(407, 'Proxy Authentication Required');
        this.i52_1 = new (HttpStatusCode())(408, 'Request Timeout');
        this.j52_1 = new (HttpStatusCode())(409, 'Conflict');
        this.k52_1 = new (HttpStatusCode())(410, 'Gone');
        this.l52_1 = new (HttpStatusCode())(411, 'Length Required');
        this.m52_1 = new (HttpStatusCode())(412, 'Precondition Failed');
        this.n52_1 = new (HttpStatusCode())(413, 'Payload Too Large');
        this.o52_1 = new (HttpStatusCode())(414, 'Request-URI Too Long');
        this.p52_1 = new (HttpStatusCode())(415, 'Unsupported Media Type');
        this.q52_1 = new (HttpStatusCode())(416, 'Requested Range Not Satisfiable');
        this.r52_1 = new (HttpStatusCode())(417, 'Expectation Failed');
        this.s52_1 = new (HttpStatusCode())(422, 'Unprocessable Entity');
        this.t52_1 = new (HttpStatusCode())(423, 'Locked');
        this.u52_1 = new (HttpStatusCode())(424, 'Failed Dependency');
        this.v52_1 = new (HttpStatusCode())(425, 'Too Early');
        this.w52_1 = new (HttpStatusCode())(426, 'Upgrade Required');
        this.x52_1 = new (HttpStatusCode())(429, 'Too Many Requests');
        this.y52_1 = new (HttpStatusCode())(431, 'Request Header Fields Too Large');
        this.z52_1 = new (HttpStatusCode())(500, 'Internal Server Error');
        this.a53_1 = new (HttpStatusCode())(501, 'Not Implemented');
        this.b53_1 = new (HttpStatusCode())(502, 'Bad Gateway');
        this.c53_1 = new (HttpStatusCode())(503, 'Service Unavailable');
        this.d53_1 = new (HttpStatusCode())(504, 'Gateway Timeout');
        this.e53_1 = new (HttpStatusCode())(505, 'HTTP Version Not Supported');
        this.f53_1 = new (HttpStatusCode())(506, 'Variant Also Negotiates');
        this.g53_1 = new (HttpStatusCode())(507, 'Insufficient Storage');
        this.h53_1 = allStatusCodes();
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = this.h53_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().hc(capacity);
        var _iterator__ex2g4s = this_0.u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          var tmp$ret$0 = element.j53_1;
          destination.c5(tmp$ret$0, element);
        }
        tmp.i53_1 = destination;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpStatusCodeClass;
function HttpStatusCode() {
  if (HttpStatusCodeClass === VOID) {
    class $ {
      constructor(value, description) {
        Companion_getInstance();
        this.j53_1 = value;
        this.k53_1 = description;
      }
      toString() {
        return '' + this.j53_1 + ' ' + this.k53_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof HttpStatusCode()) {
          tmp = other.j53_1 === this.j53_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.j53_1;
      }
      l53(other) {
        return this.j53_1 - other.j53_1 | 0;
      }
      d(other) {
        return this.l53(other instanceof HttpStatusCode() ? other : THROW_CCE());
      }
    }
    initMetadataForClass($, 'HttpStatusCode', VOID, VOID, [Comparable()]);
    HttpStatusCodeClass = $;
  }
  return HttpStatusCodeClass;
}
function allStatusCodes() {
  return listOf([Companion_getInstance().g51_1, Companion_getInstance().h51_1, Companion_getInstance().i51_1, Companion_getInstance().j51_1, Companion_getInstance().k51_1, Companion_getInstance().l51_1, Companion_getInstance().m51_1, Companion_getInstance().n51_1, Companion_getInstance().o51_1, Companion_getInstance().p51_1, Companion_getInstance().q51_1, Companion_getInstance().r51_1, Companion_getInstance().s51_1, Companion_getInstance().t51_1, Companion_getInstance().u51_1, Companion_getInstance().v51_1, Companion_getInstance().w51_1, Companion_getInstance().x51_1, Companion_getInstance().y51_1, Companion_getInstance().z51_1, Companion_getInstance().a52_1, Companion_getInstance().b52_1, Companion_getInstance().c52_1, Companion_getInstance().d52_1, Companion_getInstance().e52_1, Companion_getInstance().f52_1, Companion_getInstance().g52_1, Companion_getInstance().h52_1, Companion_getInstance().i52_1, Companion_getInstance().j52_1, Companion_getInstance().k52_1, Companion_getInstance().l52_1, Companion_getInstance().m52_1, Companion_getInstance().n52_1, Companion_getInstance().o52_1, Companion_getInstance().p52_1, Companion_getInstance().q52_1, Companion_getInstance().r52_1, Companion_getInstance().s52_1, Companion_getInstance().t52_1, Companion_getInstance().u52_1, Companion_getInstance().v52_1, Companion_getInstance().w52_1, Companion_getInstance().x52_1, Companion_getInstance().y52_1, Companion_getInstance().z52_1, Companion_getInstance().a53_1, Companion_getInstance().b53_1, Companion_getInstance().c53_1, Companion_getInstance().d53_1, Companion_getInstance().e53_1, Companion_getInstance().f53_1, Companion_getInstance().g53_1]);
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3047yo46wk0eo,
  HttpStatusCode as HttpStatusCode3o1wkms10pg4k,
};
//endregion

//# sourceMappingURL=HttpStatusCode.mjs.map
